(function() {
    'use strict';

    const DEBUG = false;
    function log() { if (DEBUG) console.log('[CPC]', ...arguments); }
    function warn() { if (DEBUG) console.warn('[CPC]', ...arguments); }


    // ============================================================
    // CONFIGURATION
    // ============================================================
    const CPC_CONFIG = {
      LOADING_TIMEOUT: 2000,
      LOADING_TIMEOUT_COLOR_CHANGE: 2000,
      LOADING_TIMEOUT_SLIDE_INJECT: 300,
    };

    // Get data from window object
    const CONFIG = window.CustomPlacementConfig || {};
    const RAW_DATA = CONFIG.rawData;
    const INIT_COLOR = CONFIG.initColor || '';
    const PRODUCT_ID = CONFIG.productId;

    if (!RAW_DATA || typeof RAW_DATA !== 'object') {
      warn('No valid monogram data');
      return;
    }

    // ============================================================
    // DATA NORMALIZATION
    // ============================================================
    const CUSTOM_DATA = {};
    for (const [colorKey, colorValue] of Object.entries(RAW_DATA)) {
      if (!colorValue || typeof colorValue !== 'object') continue;
      const categories = Array.isArray(colorValue.categories) ? colorValue.categories : [];
      CUSTOM_DATA[colorKey.toLowerCase()] = {
        categories: categories.map(cat => ({
          category: cat.category || '',
          styles: Array.isArray(cat.styles) ? cat.styles.map(style => ({
            styleId: style.styleId || Math.random(),
            name: style.name || 'Style',
            category: style.category || '',
            styleType: style.styleType || 'font_style',
            fileGid: style.fileGid || null,
            fileUrl: style.fileUrl || null,
            mimeType: style.mimeType || null,
            swatchUrl: style.swatchUrl || null,
            rules: style.rules || {},
            colors: Array.isArray(style.colors) ? style.colors.map(c => ({
              code: c.code || '',
              name: c.name || ''
            })) : [],
            placements: Array.isArray(style.placements) ? style.placements.map(p => ({
              placementId: p.placementId || Math.random(),
              key: p.key || '',
              label: p.label || '',
              svgUrl: p.svgUrl || null
            })) : []
          })) : []
        })),
        monogramPreviewImage: colorValue.monogramPreviewImage || null
      };
    }

    // ============================================================
    // DOM ELEMENTS - Inline Mode (Beta)
    // ============================================================
    const formBody = document.querySelector('.cpc-form-body');
    const desktopSlideClone = document.querySelector('#cpc-monogram-slide-desktop');
    const mobileSlideClone = document.querySelector('#cpc-monogram-slide-mobile');

    // ============================================================
    // BETA HELPER FUNCTIONS
    // ============================================================
    function getThumbSwiperWrapper() {
      return document.querySelector('.p-info-thumb .swiper-wrapper');
    }

    function getThumbSwiper() {
      return document.querySelector('.p-info-thumb');
    }

    // ============================================================
    // INJECT MONOGRAM SLIDES (BETA VERSION)
    // ============================================================
    let desktopSlideInserted = false;
    let mobileSlideInserted = false;

    function injectMonogramSlides() {
      const thumbWrapper = getThumbSwiperWrapper();
      if (!thumbWrapper) return;

      // Beta uses a single swiper - inject once
      if (desktopSlideClone && !desktopSlideInserted) {
        const clone = desktopSlideClone.cloneNode(true);
        clone.id = '';
        clone.style.display = '';
        clone.style.width = '100%';
        clone.style.height = '100%';
        
        const slideWrapper = document.createElement('div');
        slideWrapper.className = 'swiper-slide p-info-thumb-slide cpc-monogram-slide-wrapper';
        slideWrapper.dataset.media = 'monogram-preview';
        slideWrapper.appendChild(clone);
        
        thumbWrapper.insertBefore(slideWrapper, thumbWrapper.firstChild);
        desktopSlideInserted = true;
        log('Monogram slide injected into .p-info-thumb (Beta)');
      }
      
      // Reinitialize the thumb swiper after injection
      reinitializeThumbSwiper();
    }

    // ============================================================
    // RE-INITIALIZE THUMB SWIPER (Beta specific)
    // ============================================================


    function reinitializeThumbSwiper() {
      const thumbEl = getThumbSwiper();
      if (!thumbEl) return;
      
      // Check if Swiper instance exists and destroy it
      if (thumbEl.swiper) {
        try {
          thumbEl.swiper.destroy(true, true);
          log('Thumb swiper destroyed');
        } catch (e) {
          warn('Error destroying swiper:', e);
        }
      }

      const productInfoEl = document.querySelector('product-information');
      if (productInfoEl && productInfoEl.thumbSwiper) {
        try {
          productInfoEl.thumbSwiper.destroy(true, true);
        } catch (e) {}
        productInfoEl.thumbSwiper = null;
      }
      
      // Scoped nav/pagination nodes — the zoom popup builds its own in document.body
      const paginationEl = thumbEl.querySelector('.swiper-pagination');
      const nextEl = thumbEl.querySelector('.swiper-button-next');
      const prevEl = thumbEl.querySelector('.swiper-button-prev');

      // Re-initialize with Beta's config (matching product-information-v2.js)
      const hasSingleSlide = thumbEl.hasAttribute('data-single-slide')
        || !!thumbEl.querySelector('[data-single-slide], [data-single-slide="true"]');
      
      const baseConfig = {
        slidesPerView: 'auto',
        spaceBetween: 0,
        autoHeight: true,
        watchOverflow: false,
        pagination: {
          el: paginationEl,
          type: 'fraction',
          clickable: true,
          formatFractionTotal: function () {
            const sw = thumbEl.swiper;
            return sw && sw.slides ? sw.slides.length : 0;
          },
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        breakpoints: {
          0:   { slidesPerView: 1, spaceBetween: 0, autoHeight: false, grabCursor: true, },
          500: { slidesPerView: 1, spaceBetween: 0, autoHeight: false, freeMode: true, },
          650: { slidesPerView: 1, spaceBetween: 0, autoHeight: false, freeMode: true, },
          769: { slidesPerView: 'auto', spaceBetween: 0, grabCursor: true, freeMode: true, },
        },
      };

      const singleSlideOverrides = hasSingleSlide ? {
        slidesPerView: 1,
        loop: false,
        breakpoints: {
          0:   { slidesPerView: 1, autoHeight: true, spaceBetween: 0, autoHeight: false },
          500: { slidesPerView: 1, autoHeight: true, spaceBetween: 0, autoHeight: false },
          769: { slidesPerView: 1, autoHeight: true, spaceBetween: 0 },
        },
      } : {};

      const config = { ...baseConfig, ...singleSlideOverrides, initialSlide: 0, };
      
      // Reinitialize
      const newSwiper = new Swiper(thumbEl, config);
      thumbEl.swiper = newSwiper;
      
      // Update the product-information's reference if it exists
      const productInfo = document.querySelector('product-information');
      if (productInfo) {
        productInfo.thumbSwiper = newSwiper;
      }

      // This rebuild destroys with cleanStyles, wiping any transform set
      // beforehand — re-pin the SGB preview slide if one is present.
      if (productInfo && typeof productInfo.pinPreviewSlide === 'function') {
        productInfo.pinPreviewSlide();
      }
      
      log('Thumb swiper reinitialized (Beta)');
    }

    // ============================================================
    // INJECT MONOGRAM SLIDES ON FIRST INTERACTION (Beta version)
    // ============================================================
    let slidesInjected = false;

    function injectMonogramSlidesOnFirstInteraction() {
      if (slidesInjected) return;
      
      setLoadingState(true, CPC_CONFIG.LOADING_TIMEOUT_SLIDE_INJECT);
      
      if (!desktopSlideClone || !mobileSlideClone) {
        warn('Slide clones not found');
        setLoadingState(false);
        return;
      }
      
      const thumbWrapper = getThumbSwiperWrapper();
      
      // Check if slides already exist
      const existingSlides = thumbWrapper ? thumbWrapper.querySelector('.cpc-monogram-slide-wrapper') : null;
      
      if (existingSlides) {
        log('Slides already exist, reinitializing only');
        slidesInjected = true;
        reinitializeThumbSwiper();
        setTimeout(function() {
          try {
            updatePreviewImage();
            updateMonogramDisplay();
          } catch (error) {
            warn('Error updating preview:', error);
          }
        }, 100);
        return;
      }
      
      // Inject into Beta's .p-info-thumb .swiper-wrapper
      if (thumbWrapper && desktopSlideClone) {
        const clone = desktopSlideClone.cloneNode(true);
        clone.id = '';
        clone.style.display = '';
        clone.style.width = '100%';
        clone.style.height = '100%';
        
        const slideWrapper = document.createElement('div');
        slideWrapper.className = 'swiper-slide p-info-thumb-slide cpc-monogram-slide-wrapper';
        slideWrapper.dataset.media = 'monogram-preview';
        slideWrapper.appendChild(clone);
        
        thumbWrapper.insertBefore(slideWrapper, thumbWrapper.firstChild);
        log('Monogram slide injected on first interaction (Beta)');
      }


      slidesInjected = true;
      
      // Reinitialize the thumb swiper
      reinitializeThumbSwiper();
      
      // Re-initialize product information components
      const productInfo = document.querySelector('product-information');
      if (productInfo) {
        try {
          if (typeof productInfo.initZoomListeners === 'function') {
            productInfo.initZoomListeners();
            log('initZoomListeners called');
          }
          if (typeof productInfo.initThumbSlider === 'function') {
            productInfo.initThumbSlider();
            log('initThumbSlider called');
          }
        } catch (error) {
          warn('Error reinitializing product info:', error);
        }
      }

      // ── Slide to the monogram slide (index 0) after injection ──
      setTimeout(function() {
        const thumbEl = getThumbSwiper();
        if (thumbEl && thumbEl.swiper) {
          // Update the swiper to recognize the new slide
          thumbEl.swiper.update();
          
          // Force slide to index 0 (monogram slide)
          thumbEl.swiper.slideTo(0, 0);
          
          log('Swiper slid to monogram slide (index 0) after injection');
        }
        
        try {
          updatePreviewImage();
          updateMonogramDisplay();
        } catch (error) {
          warn('Error updating preview:', error);
        }
      }, 150);
    }

    // ============================================================
    // ACTIVATE MONOGRAM PREVIEW ON INTERACTION (Beta version)
    // ============================================================
    function activateMonogramPreview() {
      const thumbEl = getThumbSwiper();
      if (!thumbEl) return;
      
      // Find and slide to monogram slide
      const slides = thumbEl.querySelectorAll('.swiper-slide');
      let monogramIndex = -1;
      slides.forEach((slide, index) => {
        if (slide.classList.contains('cpc-monogram-slide-wrapper')) {
          monogramIndex = index;
        }
      });
      
      if (monogramIndex !== -1 && thumbEl.swiper) {
        if (monogramIndex !== thumbEl.swiper.activeIndex) {
          thumbEl.swiper.slideTo(monogramIndex, 300);
          log('Swiper slid to monogram slide at index:', monogramIndex);
        } else {
          log('Monogram slide is already active');
        }
      }
    }

    // ============================================================
    // UPDATE PREVIEW IMAGE (Beta version)
    // ============================================================
    function updatePreviewImage() {
      const colorData = getColorData();
      let src = null, alt = '';

      if (colorData?.monogramPreviewImage?.originalSrc) {
        src = colorData.monogramPreviewImage.originalSrc;
        alt = colorData.monogramPreviewImage.altText || '';
      }

      // Update the monogram slide image inside the swiper
      const monogramSlide = document.querySelector('.cpc-monogram-slide-wrapper');
      if (monogramSlide) {
        // Update desktop image
        const desktopImg = monogramSlide.querySelector('.cpc-desktop-preview-img');
        if (desktopImg) {
          desktopImg.src = src || '';
          desktopImg.alt = alt;
          desktopImg.style.display = src ? 'block' : 'none';
        }
        
        // Update mobile image
        const mobileImg = monogramSlide.querySelector('.cpc-mobile-preview-img');
        if (mobileImg) {
          mobileImg.src = src || '';
          mobileImg.alt = alt;
          mobileImg.style.display = src ? 'block' : 'none';
        }
        
        // Update picture elements
        const pictures = monogramSlide.querySelectorAll('picture');
        pictures.forEach(picture => {
          const sources = picture.querySelectorAll('source');
          sources.forEach(source => {
            if (source.srcset) {
              const currentWidth = source.srcset.match(/width=(\d+)/);
              if (currentWidth) {
                source.srcset = src ? `${src}&width=${currentWidth[1]}` : '';
              }
            }
          });
          const img = picture.querySelector('img');
          if (img && src) {
            img.src = src;
            img.alt = alt;
          }
        });
      }
    }

    // ============================================================
    // STATE
    // ============================================================
    let state = {
      colorKey: INIT_COLOR || Object.keys(CUSTOM_DATA)[0] || '',
      selectedCategory: null,
      selectedStyle: null,
      selectedColor: null,
      selectedPlacement: null,
      currentText: ''
    };

    let isInitialized = false;

    function getColorData() { return CUSTOM_DATA[state.colorKey] || null; }

    function getCategories() {
      const data = getColorData();
      return data?.categories || [];
    }

    function getStylesForCategory(categoryName) {
      const categories = getCategories();
      const category = categories.find(c => c.category === categoryName);
      return category?.styles || [];
    }

    function getCurrentStyle() {
      if (!state.selectedCategory) return null;
      const styles = getStylesForCategory(state.selectedCategory);
      return styles.find(s => s.styleId === state.selectedStyle) || styles[0] || null;
    }

    function getCurrentPlacement() {
      const style = getCurrentStyle();
      if (!style) return null;
      return style.placements.find(p => p.placementId === state.selectedPlacement) || style.placements[0] || null;
    }

    function getCurrentColor() {
      const style = getCurrentStyle();
      if (!style) return null;
      return style.colors.find(c => c.code === state.selectedColor) || style.colors[0] || null;
    }

    // ============================================================
    // LOADING STATE MANAGEMENT
    // ============================================================
    let isLoading = false;
    let loadingQueue = [];

    function setLoadingState(loading, duration) {
      const wrapper = document.querySelector('.cpc-placement-wrapper.cpc-placement-block-wrapper');
      if (!wrapper) return;
      
      if (wrapper._loadingTimeout) {
        clearTimeout(wrapper._loadingTimeout);
        wrapper._loadingTimeout = null;
      }
      
      isLoading = loading;
      
      if (loading) {
        wrapper.classList.add('loading');
        if (duration && duration > 0) {
          wrapper._loadingTimeout = setTimeout(function() {
            setLoadingState(false);
          }, duration);
        }
      } else {
        wrapper.classList.remove('loading');
        processLoadingQueue();
      }
    }

    function queueAction(action) {
      loadingQueue.push(action);
    }

    function processLoadingQueue() {
      while (loadingQueue.length > 0) {
        const action = loadingQueue.shift();
        if (typeof action === 'function') {
          action();
        }
      }
    }

    function isReady() {
      return !isLoading;
    }

    function waitForReady(action) {
      if (isReady()) {
        action();
      } else {
        queueAction(action);
      }
    }

    // ============================================================
    // UPDATE MONOGRAM DISPLAY
    // ============================================================
    async function updateMonogramDisplay() {
      const style = getCurrentStyle();
      const colorObj = getCurrentColor();
      const text = state.currentText || '';
      const isMobileView = isMobile();

      if (!style) return;

      const imgWrap = document.querySelector('.cpc-monogram-slide-wrapper .cpc-preview-img-wrap');
      const fontCanvas = document.querySelector('.cpc-monogram-slide-wrapper .cpc-embroidery-canvas');
      const color = colorObj?.code || '#000';

      // Update preview image
      updatePreviewImage();

      // Show/hide empty state
      const emptyStateEl = document.querySelector('.cpc-monogram-slide-wrapper .cpc-empty-state');
      if (emptyStateEl) {
        if (text.length === 0) {
          emptyStateEl.classList.add('visible');
        } else {
          emptyStateEl.classList.remove('visible');
        }
      }

      // Hide monogram elements when no text
      if (text.length === 0) {
        if (imgWrap) imgWrap.classList.remove('has-svg');
        clearSvgDisplay(isMobileView);
        clearTextDisplay(isMobileView);
        if (fontCanvas) fontCanvas.classList.remove('active');
        return;
      }

      // For block_style (Circle, Diamond) - show SVG directly
      if (style.styleType === 'block_style') {
        if (fontCanvas) fontCanvas.classList.remove('active');
        clearTextDisplay(isMobileView);
        const svgSuccess = await updateSvgMonogram(text, style, color, isMobileView);
        if (svgSuccess && imgWrap) {
          imgWrap.classList.add('has-svg');
        } else {
          if (imgWrap) imgWrap.classList.remove('has-svg');
          updateTextMonogram(text, style, color, isMobileView);
        }
        return;
      }

      // For font_style - use embroidery canvas directly (NO SVG)
      if (shouldUseSvgForMonogram(style)) {
        if (fontCanvas) fontCanvas.classList.remove('active');
        const svgSuccess = await updateSvgMonogram(text, style, color, isMobileView);
        if (svgSuccess && imgWrap) {
          imgWrap.classList.add('has-svg');
        } else {
          if (imgWrap) imgWrap.classList.remove('has-svg');
          updateTextMonogram(text, style, color, isMobileView);
        }
      } else {
        if (imgWrap) imgWrap.classList.remove('has-svg');
        clearSvgDisplay(isMobileView);
        clearTextDisplay(isMobileView);
        
        let fontFamily = style.name || 'Arial';
        if (style.fileUrl) {
          fontFamily = `'cpc-font-${style.styleId}'`;
        }
        
        renderEmbroideryOnCanvas(fontCanvas, text, color, fontFamily, isMobileView);
      }
    }

    // ============================================================
    // CLEAR SVG DISPLAY
    // ============================================================
    function clearSvgDisplay(isMobileView) {
      const svgContainer = document.querySelector('.cpc-monogram-slide-wrapper .cpc-svg-monogram');
      if (svgContainer) {
        svgContainer.style.display = 'none';
        const left = svgContainer.querySelector('[data-svg-left]');
        const center = svgContainer.querySelector('[data-svg-center]');
        const right = svgContainer.querySelector('[data-svg-right]');
        if (left) left.innerHTML = '';
        if (center) center.innerHTML = '';
        if (right) right.innerHTML = '';
      }
    }

    // ============================================================
    // CLEAR TEXT DISPLAY
    // ============================================================
    function clearTextDisplay(isMobileView) {
      const monogramOverlay = document.querySelector('.cpc-monogram-slide-wrapper .cpc-monogram-overlay');
      if (monogramOverlay) {
        monogramOverlay.textContent = '';
      }
    }

    // ============================================================
    // IS MOBILE
    // ============================================================
    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    // ============================================================
    // SHOULD USE SVG FOR MONOGRAM
    // ============================================================
    function shouldUseSvgForMonogram(style) {
      if (!style) return false;
      if (style.styleType === 'block_style') return true;
      const fontName = style.name.toLowerCase();
      return window.MONOGRAM_SVGS && window.MONOGRAM_SVGS[fontName];
    }

    // ============================================================
    // GET SVG FROM VARIABLE
    // ============================================================
    function getSvgFromVariable(fontName, letter, position) {
      const font = fontName.toLowerCase().trim();
      const upper = letter.toUpperCase();
      return window.MONOGRAM_SVGS?.[font]?.[upper]?.[position] || null;
    }

    function getLetterWidth(fontName, letter, position) {
      const font = fontName.toLowerCase().trim();
      const upper = letter.toUpperCase();
      return window.MONOGRAM_LAYOUT?.[font]?.[upper]?.[position] || null;
    }

    // ============================================================
    // UPDATE SVG MONOGRAM
    // ============================================================
    async function updateSvgMonogram(text, style, color, isMobileView) {
      if (!text || text.length === 0) return false;

      const raw = text.toUpperCase().replace(/[^A-Z]/g, '');

      let slots = { left: '', center: '', right: '' };
      if (raw.length === 1) { slots.center = raw[0]; } 
      else if (raw.length === 2) { slots.left = raw[0]; slots.right = raw[1]; } 
      else if (raw.length >= 3) { slots.left = raw[0]; slots.center = raw[1]; slots.right = raw[2]; }

      const svgContainer = document.querySelector('.cpc-monogram-slide-wrapper .cpc-svg-monogram');
      if (!svgContainer) return false;

      const svgLeft = svgContainer.querySelector('[data-svg-left]');
      const svgCenter = svgContainer.querySelector('[data-svg-center]');
      const svgRight = svgContainer.querySelector('[data-svg-right]');

      const positions = [
        { pos: 'left', container: svgLeft },
        { pos: 'center', container: svgCenter },
        { pos: 'right', container: svgRight },
      ];

      let hasAllSymbols = true;
      let hasAnyLetter = false;

      if (svgContainer) {
        svgContainer.style.top = '50%';
        svgContainer.style.left = '50%';
        svgContainer.style.transform = 'translate(-50%, -50%)';
      }

      const fontName = style.name;

      for (const { pos: positionName, container } of positions) {
        if (!container) continue;
        const letter = slots[positionName];

        if (letter) {
          hasAnyLetter = true;
          const svgString = getSvgFromVariable(fontName, letter, positionName);
          if (svgString) {
            if (container.innerHTML !== svgString) container.innerHTML = svgString;
            const letterWidth = getLetterWidth(fontName, letter, positionName);
            if (letterWidth) {
              container.style.width = `${letterWidth}%`;
              container.style.flex = `0 0 ${letterWidth}%`;
            } else {
              container.style.width = 'auto';
              container.style.flex = '0 0 auto';
            }
            container.style.display = 'inline-flex';
            container.style.alignItems = 'center';
            container.style.justifyContent = 'center';
            const svgEl = container.querySelector('svg');
            if (svgEl) svgEl.style.color = color;
          } else {
            hasAllSymbols = false;
            container.innerHTML = '';
            container.style.display = 'none';
          }
        } else {
          container.innerHTML = '';
          container.style.display = 'none';
        }
      }

      if (svgContainer) svgContainer.style.display = hasAnyLetter ? 'block' : 'none';
      return hasAllSymbols && hasAnyLetter;
    }

    // ============================================================
    // UPDATE TEXT MONOGRAM
    // ============================================================
    function updateTextMonogram(text, style, color, isMobileView) {
      clearSvgDisplay(isMobileView);

      const fontTag = (style && style.styleType === 'font_style') ? `cpc-font-${style.styleId}` : 'inherit';
      const target = document.querySelector('.cpc-monogram-slide-wrapper .cpc-monogram-overlay');

      let displayText = text || '';
      const rules = style?.rules || {};
      
      if (rules.inputType === 'date' && text) {
        const digits = text.replace(/[^0-9]/g, '');
        if (digits.length > 0) {
          let formatted = digits;
          if (digits.length > 2) {
            formatted = digits.slice(0, 2) + '-' + digits.slice(2);
          }
          if (digits.length > 4) {
            formatted = digits.slice(0, 2) + '-' + digits.slice(2, 4) + '-' + digits.slice(4);
          }
          displayText = formatted;
        } else {
          displayText = '';
        }
      }

      if (target) {
        target.textContent = displayText;
        target.style.color = color || '#000';
        target.style.fontFamily = `'${fontTag}'`;
        target.style.fontSize = '24px';
        target.style.top = '50%';
        target.style.left = '50%';
        target.style.transform = 'translate(-50%, -50%)';
        target.style.display = text ? 'block' : 'none';
      }

      const svgContainer = document.querySelector('.cpc-monogram-slide-wrapper .cpc-svg-monogram');
      if (svgContainer) svgContainer.style.display = 'none';
    }

    // ============================================================
    // EMBROIDERY RENDERING ENGINE
    // ============================================================
    function hexToRgb(hex) {
      hex = hex.trim();
      if (hex[0] !== '#') {
        const d = document.createElement('div');
        d.style.color = hex;
        document.body.appendChild(d);
        const computed = getComputedStyle(d).color;
        document.body.removeChild(d);
        const m = computed.match(/\d+/g);
        return { r: +m[0], g: +m[1], b: +m[2] };
      }
      let h = hex.replace('#', '');
      if (h.length === 3) h = h.split('').map(c => c + c).join('');
      const num = parseInt(h, 16);
      return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
    }

    function shadeRGB(rgb, amt) {
      const f = (c) => {
        let v = amt > 0 ? c + (255 - c) * amt : c + c * amt;
        return Math.max(0, Math.min(255, Math.round(v)));
      };
      return { r: f(rgb.r), g: f(rgb.g), b: f(rgb.b) };
    }

    function shade(rgb, amt) {
      const s = shadeRGB(rgb, amt);
      return `rgb(${s.r}, ${s.g}, ${s.b})`;
    }

    function rgba(rgb, a) {
      return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${a})`;
    }

    function makeRng(seed) {
      let s = seed % 2147483647;
      if (s <= 0) s += 2147483646;
      return function() {
        s = (s * 16807) % 2147483647;
        return (s - 1) / 2147483646;
      };
    }

    function fontWeightFor(fontFamily) {
      return /script|cursive/i.test(fontFamily) ? '600' : '700';
    }

    function fitFontSize(text, fontFamily, canvasWidth, canvasHeight) {
      const off = document.createElement('canvas');
      off.width = canvasWidth;
      off.height = canvasHeight;
      const offCtx = off.getContext('2d');
      
      const weight = fontWeightFor(fontFamily);
      const maxW = canvasWidth * 0.86;
      const maxH = canvasHeight * 0.5;
      let lo = 10, hi = 160, best = 40;
      offCtx.save();
      while (lo <= hi) {
        const mid = (lo + hi) >> 1;
        offCtx.font = `${weight} ${mid}px ${fontFamily}`;
        const m = offCtx.measureText(text || ' ');
        const w = m.width;
        const h = (m.actualBoundingBoxAscent || mid * 0.8) + (m.actualBoundingBoxDescent || mid * 0.2);
        if (w <= maxW && h <= maxH) {
          best = mid;
          lo = mid + 1;
        } else {
          hi = mid - 1;
        }
      }
      offCtx.restore();
      return best;
    }

    function getTextMask(text, fontFamily, fontSize, canvasWidth, canvasHeight) {
      const off = document.createElement('canvas');
      off.width = canvasWidth;
      off.height = canvasHeight;
      const offCtx = off.getContext('2d');
      
      const weight = fontWeightFor(fontFamily);
      offCtx.clearRect(0, 0, canvasWidth, canvasHeight);
      offCtx.fillStyle = '#000';
      offCtx.font = `${weight} ${fontSize}px ${fontFamily}`;
      offCtx.textAlign = 'center';
      offCtx.textBaseline = 'alphabetic';
      const cx = canvasWidth / 2;
      const cy = canvasHeight / 2 + fontSize * 0.32;
      offCtx.fillText(text, cx, cy);
      const imgData = offCtx.getImageData(0, 0, canvasWidth, canvasHeight);
      return { data: imgData.data, baselineY: cy, cx: cx };
    }

    function isFilled(maskData, x, y, canvasWidth, canvasHeight) {
      if (x < 0 || x >= canvasWidth || y < 0 || y >= canvasHeight) return false;
      const idx = (y * canvasWidth + x) * 4 + 3;
      return maskData[idx] > 80;
    }

    function getColumnRuns(maskData, canvasWidth, canvasHeight) {
      const runs = [];
      for (let x = 0; x < canvasWidth; x++) {
        const colRuns = [];
        let inRun = false, top = 0;
        for (let y = 0; y < canvasHeight; y++) {
          const f = isFilled(maskData, x, y, canvasWidth, canvasHeight);
          if (f && !inRun) { inRun = true; top = y; }
          if (!f && inRun) { inRun = false; colRuns.push([top, y - 1]); }
        }
        if (inRun) colRuns.push([top, canvasHeight - 1]);
        runs.push(colRuns);
      }
      return runs;
    }

    function columnFilledAt(runs, x, y) {
      if (x < 0 || x >= runs.length) return false;
      const colRuns = runs[x];
      for (let i = 0; i < colRuns.length; i++) {
        if (y >= colRuns[i][0] && y <= colRuns[i][1]) return true;
      }
      return false;
    }

    function drawSatinFill(ctx, runs, spacing, lineWidth, passes, color, rng, opts, canvasWidth, canvasHeight) {
      opts = opts || {};
      ctx.lineCap = 'round';
      ctx.strokeStyle = color;
      ctx.lineWidth = lineWidth;

      const step = Math.max(1, Math.round(spacing));
      for (let y = 0; y < canvasHeight; y += step) {
        let x = 0;
        while (x < canvasWidth) {
          if (columnFilledAt(runs, x, y)) {
            let xStart = x;
            while (x < canvasWidth && columnFilledAt(runs, x, y)) x++;
            let xEnd = x;
            const midY = y + (opts.flat ? 0 : (rng() - 0.5) * spacing * 0.5);
            ctx.beginPath();
            ctx.moveTo(xStart, midY - 0.6);
            ctx.lineTo(xEnd, midY + 0.6);
            ctx.stroke();
          } else {
            x++;
          }
        }
      }
    }

    function drawStitchDashes(ctx, runs, spacing, threadW, rgb, rng, canvasWidth, canvasHeight) {
      const dashColorDark = shade(rgb, -0.22);
      const dashColorLight = shade(rgb, 0.18);
      const step = Math.max(2, Math.round(spacing));

      ctx.lineCap = 'round';

      for (let x = 0; x < canvasWidth; x += step) {
        const colRuns = runs[x];
        for (let r = 0; r < colRuns.length; r++) {
          const top = colRuns[r][0], bottom = colRuns[r][1];
          if (bottom - top < 1) continue;
          const segH = Math.max(3, spacing * 1.4);
          for (let y = top; y <= bottom; y += segH) {
            const yEnd = Math.min(bottom, y + segH * 0.92);
            const slant = (rng() - 0.5) * 2.0;
            const alt = rng();
            ctx.strokeStyle = alt > 0.5 ? dashColorDark : dashColorLight;
            ctx.globalAlpha = 0.55 + alt * 0.25;
            ctx.lineWidth = Math.max(0.6, threadW * 0.22);
            ctx.beginPath();
            ctx.moveTo(x - threadW * 0.3 + slant, y);
            ctx.lineTo(x + threadW * 0.3 - slant, yEnd);
            ctx.stroke();
          }
        }
      }
      ctx.globalAlpha = 1;
    }

    function drawHighlightSheen(ctx, runs, spacing, threadW, rgb, rng, canvasWidth, canvasHeight) {
      const highlightRGB = shadeRGB(rgb, 0.62);
      const superHighlightRGB = shadeRGB(rgb, 0.85);

      ctx.lineCap = 'round';

      const step = Math.max(1, Math.round(spacing));
      for (let x = 0; x < canvasWidth; x += step) {
        const colRuns = runs[x];
        for (let r = 0; r < colRuns.length; r++) {
          const top = colRuns[r][0], bottom = colRuns[r][1];
          const runHeight = bottom - top;
          if (runHeight < 1) continue;
          const bandTop = top;
          const bandBottom = top + Math.max(1, runHeight * 0.32);

          const grad = ctx.createLinearGradient(x, bandTop, x, bandBottom + (bandBottom - bandTop));
          grad.addColorStop(0, rgba(superHighlightRGB, 0.85));
          grad.addColorStop(0.45, rgba(highlightRGB, 0.45));
          grad.addColorStop(1, rgba(rgb, 0));

          ctx.strokeStyle = grad;
          ctx.lineWidth = Math.max(1, threadW * 0.55);
          ctx.beginPath();
          ctx.moveTo(x, bandTop);
          ctx.lineTo(x, bandBottom);
          ctx.stroke();

          if (rng() > 0.86) {
            ctx.fillStyle = rgba(superHighlightRGB, 0.9);
            ctx.beginPath();
            ctx.arc(x + (rng() - 0.5) * 1.5, bandTop + (bandBottom - bandTop) * 0.3, threadW * 0.18, 0, Math.PI * 2);
            ctx.fill();
          }
        }
      }
    }

    function renderEmbroideryOnCanvas(canvas, text, color, fontFamily, isMobileView) {
      if (!canvas || !text || !text.trim()) {
        if (canvas) canvas.classList.remove('active');
        return;
      }

      const ctx = canvas.getContext('2d');
      const W = canvas.width;
      const H = canvas.height;

      ctx.clearRect(0, 0, W, H);

      let displayText = text;
      const style = getCurrentStyle();
      if (style && style.rules && style.rules.inputType === 'date') {
        const digits = text.replace(/[^0-9]/g, '');
        if (digits.length > 0) {
          let formatted = digits;
          if (digits.length > 2) {
            formatted = digits.slice(0, 2) + '-' + digits.slice(2);
          }
          if (digits.length > 4) {
            formatted = digits.slice(0, 2) + '-' + digits.slice(2, 4) + '-' + digits.slice(4);
          }
          displayText = formatted;
        }
      }

      const rgb = hexToRgb(color);
      const isWhiteish = (rgb.r > 240 && rgb.g > 240 && rgb.b > 240);

      const thickness = 2;
      const density = 6;
      const showStitches = true;
      const showHighlight = false;
      const showShadow = false;

      const fontSize = fitFontSize(displayText, fontFamily, W, H);
      const mask = getTextMask(displayText, fontFamily, fontSize, W, H);
      const runs = getColumnRuns(mask.data, W, H);

      const spacing = Math.max(2, 9 - density * 1.3);
      const threadW = 1.2 + thickness * 1.5;
      const numLayers = Math.min(5, Math.max(2, Math.round(thickness * 1.1) + 1));

      const rng = makeRng(hashStr(displayText + fontFamily + color));

      if (showShadow) {
        ctx.save();
        ctx.translate(2.5, 4);
        ctx.globalAlpha = 0.32;
        drawSatinFill(ctx, runs, spacing, threadW, numLayers, '#000000', rng, { flat: true }, W, H);
        ctx.restore();
      }

      for (let layer = 0; layer < numLayers; layer++) {
        const t = numLayers <= 1 ? 0 : layer / (numLayers - 1);
        const layerShade = -0.38 + t * 0.5;
        const jitter = (numLayers - layer) * 0.35;
        ctx.save();
        ctx.translate(
          (rng() - 0.5) * jitter * 0.6,
          (rng() - 0.5) * jitter * 0.6
        );
        const layerColor = shade(rgb, layerShade);
        const lw = threadW * (1 - layer * 0.08);
        drawSatinFill(ctx, runs, spacing, lw, 1, layerColor, rng, {}, W, H);
        ctx.restore();
      }

      if (showStitches) {
        drawStitchDashes(ctx, runs, spacing, threadW, rgb, rng, W, H);
      }

      if (showHighlight) {
        drawHighlightSheen(ctx, runs, spacing, threadW, rgb, rng, W, H);
      }

      if (isWhiteish) {
        ctx.save();
        ctx.globalAlpha = 0.5;
        ctx.strokeStyle = 'rgba(0,0,0,0.18)';
        ctx.lineWidth = 1;
        for (let x = 0; x < W; x++) {
          const colRuns = runs[x];
          for (let r = 0; r < colRuns.length; r++) {
            ctx.beginPath();
            ctx.moveTo(x, colRuns[r][0]);
            ctx.lineTo(x, colRuns[r][1]);
            ctx.stroke();
          }
        }
        ctx.restore();
      }

      canvas.classList.add('active');
    }

    function hashStr(s) {
      let h = 0;
      for (let i = 0; i < s.length; i++) { h = (h * 31 + s.charCodeAt(i)) | 0; }
      return Math.abs(h) || 1;
    }

    // ============================================================
    // INPUT TYPE COMPATIBILITY HELPERS
    // ============================================================
    function getInputTypeCategory(rules) {
      if (!rules || Object.keys(rules).length === 0) {
        return 'text';
      }
      const inputType = rules?.inputType || 'text';
      if (inputType === 'alphanumeric') return 'alphanumeric';
      if (inputType === 'letters') return 'letters';
      if (inputType === 'numbers') return 'numbers';
      if (inputType === 'date') return 'date';
      return 'text';
    }

    function isInputCompatible(newRules, currentText) {
      const newType = getInputTypeCategory(newRules);
      
      if (!currentText || currentText.length === 0) {
        return true;
      }
      
      if (newType === 'numbers') {
        return /^[0-9]*$/.test(currentText);
      }
      if (newType === 'letters') {
        return /^[a-zA-Z]*$/.test(currentText);
      }
      if (newType === 'alphanumeric') {
        return /^[a-zA-Z0-9]*$/.test(currentText);
      }
      if (newType === 'date') {
        return /^[0-9]*$/.test(currentText);
      }
      return true;
    }

    // ============================================================
    // TOOLTIP NOTIFICATION
    // ============================================================
    var tooltipElement = null;
    var tooltipTimeout = null;

    function createTooltip(message) {
      removeTooltip();
      var tooltip = document.createElement('div');
      tooltip.className = 'cpc-tooltip-notification';
      tooltip.id = 'cpc-tooltip-notification';
      tooltip.innerHTML = '<span class="cpc-tooltip-icon">⚠️</span><span class="cpc-tooltip-text">' + (message || 'Please select a category first') + '</span>';
      document.body.appendChild(tooltip);
      tooltipElement = tooltip;
      requestAnimationFrame(function() {
        tooltip.classList.add('show');
      });
      return tooltip;
    }

    function showTooltip(message, duration) {
      duration = duration || 3000;
      removeTooltip();
      var tooltip = createTooltip(message);
      if (tooltipTimeout) {
        clearTimeout(tooltipTimeout);
        tooltipTimeout = null;
      }
      
      scrollToCategorySection();
      
      tooltipTimeout = setTimeout(function() {
        hideTooltip();
      }, duration);
    }



    function scrollToCategorySection() {
      // Find the category grid container
      var categoryGrid = document.querySelector('.cpc-category-grid');
      if (!categoryGrid) {
          var categorySection = document.querySelector('.cpc-section');
          if (!categorySection) {
              categorySection = document.querySelector('.cpc-form-body');
              if (!categorySection) {
                  categorySection = document.querySelector('.cpc-placement-wrapper');
              }
          }
          if (!categorySection) return;
          categoryGrid = categorySection;
      }

      var isDesktop = window.innerWidth >= 1201;

      if (isDesktop) {
          // Desktop: Scroll .p-info-top to the top
          var pInfoTop = document.querySelector('.p-info-top');
          if (pInfoTop) {
              pInfoTop.scrollTop = 0;
              pInfoTop.scrollTo({ top: 0, behavior: 'smooth' });

              setTimeout(function() {
                  pInfoTop.scrollTop = 0;
                  pInfoTop.scrollTo({ top: 0, behavior: 'smooth' });
              }, 50);

              setTimeout(function() {
                  pInfoTop.scrollTop = 0;
                  pInfoTop.scrollTo({ top: 0, behavior: 'smooth' });
              }, 200);
          }
      } else {
          // Mobile: center categoryGrid in the viewport
          function centerGrid() {
              var rect = categoryGrid.getBoundingClientRect();
              var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
              var windowHeight = window.innerHeight;
              var elementHeight = rect.height;

              // If the grid is taller than the viewport, center on its midpoint
              // instead of trying to fit the whole element (which is impossible).
              var elementMid = rect.top + scrollTop + elementHeight / 2;
              var targetPosition = elementMid - windowHeight / 2;

              window.scrollTo({
                  top: Math.max(0, targetPosition),
                  behavior: 'smooth'
              });
          }

          // Do it once now...
          centerGrid();

          // ...and again shortly after, in case content/images inside the
          // grid change its height/position right after becoming visible.
          setTimeout(centerGrid, 50);
          setTimeout(centerGrid, 200);
      }
    }

    function hideTooltip() {
      if (tooltipElement) {
        tooltipElement.classList.remove('show');
        var onTransitionEnd = function() {
          removeTooltip();
          tooltipElement.removeEventListener('transitionend', onTransitionEnd);
        };
        tooltipElement.addEventListener('transitionend', onTransitionEnd);
        setTimeout(function() {
          if (tooltipElement) {
            removeTooltip();
          }
        }, 500);
      }
      if (tooltipTimeout) {
        clearTimeout(tooltipTimeout);
        tooltipTimeout = null;
      }
    }

    function removeTooltip() {
      if (tooltipElement && tooltipElement.parentNode) {
        tooltipElement.parentNode.removeChild(tooltipElement);
      }
      tooltipElement = null;
    }

    // ============================================================
    // RENDER FORM SECTIONS
    // ============================================================
    function getTodayDateString() {
      const today = new Date();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const year = String(today.getFullYear()).slice(-2);
      return `${month}-${day}-${year}`;
    }

    function getFontPreviewContent(style) {
      const styleRules = style.rules || {};

      if (style.styleType === 'block_style') {
        if (style.swatchUrl) {
          return `<img src="${style.swatchUrl}" alt="${style.name}" />`;
        }
        return style.name;
      }

      const isSingleLetter = style.category === 'single letter';
      
      if (styleRules.inputType === 'date') {
        return getTodayDateString();
      }
      if (styleRules.inputType === 'numbers') {
        return isSingleLetter ? '1' : '123';
      }
      return isSingleLetter ? 'A' : 'ABC';
    }

    // ============================================================
    // FORM ROW SWIPERS
    // ============================================================
    var formSwipers = [];

    function destroyFormSwipers() {
      formSwipers.forEach(function(sw) {
        try { sw.destroy(true, true); } catch (e) { warn('Swiper destroy failed', e); }
      });
      formSwipers = [];
    }

    function initFormSwipers() {
      if (!formBody || typeof Swiper === 'undefined') return;

      formBody.querySelectorAll('.cpc-form-swiper').forEach(function(el) {
        var sw = new Swiper(el, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          watchOverflow: true,
          freeMode: {
            enabled: true,
            sticky: false,
            momentumBounce: false,
          },
          mousewheel: {
            enabled: true,
            sensitivity: 4,
          },
          scrollbar: {
            el: el.querySelector('.swiper-scrollbar'),
            draggable: true,
            hide: false
          },
          on: {
            lock: function() {
              this.mousewheel.disable();
            },
            unlock: function() {
              this.mousewheel.enable();
            },
            init: function() {
              if (this.isLocked) {
                this.mousewheel.disable();
              }
            }
          }
        });
        formSwipers.push(sw);
      });

      log('Form swipers initialized:', formSwipers.length);
    }

    // ============================================================
    // RENDER SECTIONS
    // ============================================================
    function renderSections() {
      var categories = getCategories();
      if (!categories.length) {
        if (formBody) {
          formBody.innerHTML = '<div class="cpc-no-placements">No personalization options available.</div>';
        }
        return;
      }

      if (!formBody) return;

      destroyFormSwipers();
      formBody.innerHTML = '';
      var step = 1;

      formBody.insertAdjacentHTML('beforeend', '<div class="cpc-section"><div class="cpc-section-header"><p class="cpc-section-label"><span class="cpc-step">' + step++ + '</span> Category</p><span class="cpc-section-current">' + (state.selectedCategory || '') + '</span></div><div class="cpc-category-grid">' + categories.map(function(cat) {
        return '<button class="cpc-category-btn ' + (state.selectedCategory === cat.category ? 'selected' : '') + '" data-category="' + cat.category + '">' + cat.category + '</button>';
      }).join('') + '</div></div>');

      var categoryToShow = state.selectedCategory || (categories.length > 0 ? categories[0].category : null);
      var styles = categoryToShow ? getStylesForCategory(categoryToShow) : [];

      if (styles.length) {
        var currentStyle = state.selectedStyle ? styles.find(function(s) { return s.styleId === state.selectedStyle; }) : null;
        var currentRules = currentStyle?.rules || {};

        var styleLabel = '';
        if (currentStyle) {
          if (currentStyle.styleType === 'block_style') {
            styleLabel = currentStyle.name;
          } else if (currentRules.inputType === 'date') {
            styleLabel = 'Date';
          } else if (currentRules.inputType === 'numbers') {
            styleLabel = 'Numbers';
          } else {
            styleLabel = 'Block Letters';
          }
        }

        formBody.insertAdjacentHTML('beforeend', '<div class="cpc-section"><div class="cpc-section-header cpc-section-header--inline"><p class="cpc-section-label"><span class="cpc-step">' + step++ + '</span> Style: <span class="cpc-style-current">' + (styleLabel || '') + '</span></p></div><div class="swiper cpc-form-swiper cpc-font-swiper"><div class="swiper-wrapper cpc-font-grid">' + styles.map(function(s) {
          var previewContent = getFontPreviewContent(s);
          var isSelected = state.selectedStyle === s.styleId;
          return '<button class="swiper-slide cpc-font-card ' + (isSelected ? 'selected' : '') + '" data-style-id="' + s.styleId + '"><div class="cpc-font-preview" style="' + (s.styleType === 'font_style' && s.fileUrl ? 'font-family:\'cpc-font-' + s.styleId + '\'' : '') + '">' + previewContent + '</div><div class="cpc-font-name">' + s.name + '</div></button>';
        }).join('') + '</div><div class="swiper-scrollbar"></div></div></div>');

        styles.forEach(function(s) { ensureFontFace(s); });

        var currentStyleObj = state.selectedStyle ? styles.find(function(s) { return s.styleId === state.selectedStyle; }) : null;
        var styleForColors = currentStyleObj || styles[0];
        if (styleForColors && styleForColors.colors?.length) {
          var colorObj = state.selectedColor ? styleForColors.colors.find(function(c) { return c.code === state.selectedColor; }) : null;
          var colorDisplayLabel = colorObj?.name || colorObj?.code || '';

          formBody.insertAdjacentHTML('beforeend', '<div class="cpc-section"><div class="cpc-section-header"><p class="cpc-section-label"><span class="cpc-step">' + step++ + '</span> Thread Color</p><span class="cpc-section-current cpc-color-current-label">' + colorDisplayLabel + '</span></div><div class="swiper cpc-form-swiper cpc-color-swiper"><div class="swiper-wrapper cpc-color-swatches">' + styleForColors.colors.map(function(clr) {
            return '<div class="swiper-slide cpc-color-swatch-wrapper"><button class="cpc-color-swatch ' + (state.selectedColor === clr.code ? 'selected' : '') + '" data-color="' + clr.code + '" data-color-name="' + (clr.name || '') + '" title="' + (clr.name || clr.code) + '"><span class="cpc-color-chip" style="background:' + clr.code + ';"></span><span class="cpc-color-name">' + (clr.name || clr.code) + '</span></button></div>';
          }).join('') + '</div><div class="swiper-scrollbar"></div></div></div>');
        }

        var styleForPlacements = currentStyleObj || styles[0];
        if (styleForPlacements && styleForPlacements.placements?.length) {
          var selPlacement = styleForPlacements.placements.find(function(p) { return p.placementId === state.selectedPlacement; });
          var placementLabel = selPlacement ? selPlacement.label : '';

          formBody.insertAdjacentHTML('beforeend', '<div class="cpc-section"><div class="cpc-section-header"><p class="cpc-section-label"><span class="cpc-step">' + step++ + '</span> Placement</p><span class="cpc-section-current cpc-placement-current-label">' + placementLabel + '</span></div><div class="swiper cpc-form-swiper cpc-placement-swiper"><div class="swiper-wrapper cpc-placement-grid">' + styleForPlacements.placements.map(function(p) {
            var isSelected = state.selectedPlacement === p.placementId;
            var svgIcon = p.svgUrl ? '<img src="' + p.svgUrl + '" alt="' + p.label + '" class="cpc-placement-icon" />' : '';
            return '<button class="swiper-slide cpc-placement-btn ' + (isSelected ? 'selected' : '') + '" data-placement-id="' + p.placementId + '">' + svgIcon + '<span class="cpc-placement-label">' + p.label + '</span></button>';
          }).join('') + '</div><div class="swiper-scrollbar"></div></div></div>');
        }

        var styleForRules = currentStyleObj || styles[0];
        if (styleForRules) {
          var inputRules = styleForRules.rules || {};
          var inputType = inputRules.inputType || 'text';
          var isDate = inputType === 'date';
          var maxLen = isDate ? 6 : (inputRules.maxLength || 20);
          var minLen = isDate ? 6 : (inputRules.minLength || 0);

          var charLabel = '';
          if (isDate) charLabel = 'Format: DD-MM-YY';
          else if (minLen && minLen === maxLen) charLabel = 'Exactly ' + maxLen + ' Character' + (maxLen > 1 ? 's' : '');
          else if (minLen > 0) charLabel = 'Min. ' + minLen + ' Character' + (minLen > 1 ? 's' : '');
          else if (maxLen < 999) charLabel = 'Max. ' + maxLen + ' Character' + (maxLen > 1 ? 's' : '');

          var styleName = styleForRules?.name || '';
          var allowedHint = '';
          if (isDate) {
            allowedHint = '<strong>Instructions for ' + styleName + ':</strong> Enter 6 digits (DDMMYY). Displayed as DD-MM-YY.';
          } else if (inputType === 'letters') {
            allowedHint = '<strong>Instructions for ' + styleName + ':</strong> Letters only.';
          } else if (inputType === 'numbers') {
            allowedHint = '<strong>Instructions for ' + styleName + ':</strong> Numbers only.';
          } else if (inputType === 'alphanumeric') {
            allowedHint = '<strong>Instructions for ' + styleName + ':</strong> Letters and numbers only.';
          } else {
            allowedHint = '<strong>Instructions for ' + styleName + ':</strong> Text only.';
          }

          var rawText = state.currentText || '';
          var displayValue = rawText;
          if (isDate && rawText) {
            var digits = rawText.replace(/[^0-9]/g, '');
            if (digits.length > 0) {
              var formatted = digits;
              if (digits.length > 2) {
                formatted = digits.slice(0, 2) + '-' + digits.slice(2);
              }
              if (digits.length > 4) {
                formatted = digits.slice(0, 2) + '-' + digits.slice(2, 4) + '-' + digits.slice(4);
              }
              displayValue = formatted;
            }
          }
          var counterText = isDate ? rawText.length + '/6' : rawText.length + '/' + maxLen;

          formBody.insertAdjacentHTML('beforeend', '<div class="cpc-section"><div class="cpc-section-header"><p class="cpc-section-label"><span class="cpc-step">' + step++ + '</span> ' + (isDate ? 'Date' : 'Text') + '</p><span class="cpc-section-current">' + charLabel + '</span></div><div class="cpc-char-input-wrap"><input type="text" class="cpc-char-input" data-max="' + maxLen + '" data-min="' + minLen + '" data-input-type="' + inputType + '" maxlength="' + (isDate ? 8 : maxLen) + '" value="' + displayValue.replace(/"/g, '&quot;') + '" placeholder="' + (isDate ? 'DD-MM-YY' : 'Enter text') + '"><span class="cpc-char-counter">' + counterText + '</span></div><div class="cpc-validation-message"><span class="cpc-msg-text"></span><button class="cpc-clear-btn" data-clear-input>Clear</button></div>' + (minLen && !isDate ? '<p class="cpc-char-hint ' + (rawText.length > 0 && rawText.length < minLen ? 'cpc-error-msg' : '') + '">Minimum ' + minLen + ' character' + (minLen > 1 ? 's' : '') + ' required.</p>' : '') + (allowedHint ? '<p class="cpc-allowed-chars">' + allowedHint + '</p>' : '') + '</div>');
        }
      } else {
        formBody.insertAdjacentHTML('beforeend', '<div class="cpc-section"><div class="cpc-section-header"><p class="cpc-section-label"><span class="cpc-step">' + step++ + '</span> Styles</p></div><div class="cpc-no-fonts-msg">No styles available for this category.</div></div>');
      }

      attachEventListeners();
      initFormSwipers();
      updateAddToCartButton();
    }

    // ============================================================
    // FONT LOADING
    // ============================================================
    const loadedFonts = new Set();

    function ensureFontFace(style) {
      if (style.styleType !== 'font_style' || !style.fileUrl) return;
      const tag = `cpc-font-${style.styleId}`;
      if (loadedFonts.has(tag) || document.querySelector(`style[data-cpc-font="${tag}"]`)) return;
      const format = style.mimeType === 'font/ttf' ? 'truetype' :
        style.mimeType === 'font/otf' ? 'opentype' :
        style.mimeType === 'font/woff2' ? 'woff2' : 'woff';
      const styleEl = document.createElement('style');
      styleEl.setAttribute('data-cpc-font', tag);
      styleEl.textContent = `@font-face { font-family: '${tag}'; src: url('${style.fileUrl}') format('${format}'); font-display: swap; }`;
      document.head.appendChild(styleEl);
      loadedFonts.add(tag);
      log('Loaded font:', style.name);
    }

    // ============================================================
    // ATTACH EVENT LISTENERS
    // ============================================================
    function attachEventListeners() {
      if (!formBody) return;

      function findMatchingColor(newStyle, oldColorCode) {
        if (!oldColorCode || !newStyle.colors || newStyle.colors.length === 0) {
          return null;
        }
        return newStyle.colors.find(function(c) {
          return c.code === oldColorCode;
        });
      }

      function findMatchingPlacement(newStyle, oldPlacementId) {
        if (!oldPlacementId || !newStyle.placements || newStyle.placements.length === 0) {
          return null;
        }
        return newStyle.placements.find(function(p) {
          return p.placementId === oldPlacementId;
        });
      }

      // Category buttons
      formBody.querySelectorAll('.cpc-category-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          waitForReady(function() {
            injectMonogramSlidesOnFirstInteraction();
            
            var category = btn.dataset.category;
            state.selectedCategory = category;
            
            var styles = getStylesForCategory(category);
            if (styles.length > 0) {
              state.selectedStyle = styles[0].styleId;
              if (styles[0].colors && styles[0].colors.length > 0) {
                state.selectedColor = styles[0].colors[0].code;
              }
              if (styles[0].placements && styles[0].placements.length > 0) {
                state.selectedPlacement = styles[0].placements[0].placementId;
              }
            } else {
              state.selectedStyle = null;
              state.selectedColor = null;
              state.selectedPlacement = null;
            }
            
            state.currentText = '';
            renderSections();
            updateMonogramDisplay();
            activateMonogramPreview();
            writePropertiesToForm();
            updateValidationMessage();
          });
        });
      });

      // Style cards
      formBody.querySelectorAll('.cpc-font-card').forEach(function(btn) {
        btn.addEventListener('click', function() {
          waitForReady(function() {
            if (!state.selectedCategory) {
              showTooltip('Please select a category first');
              return;
            }
            
            injectMonogramSlidesOnFirstInteraction();
            
            var styleId = parseInt(btn.dataset.styleId, 10);
            var styles = getStylesForCategory(state.selectedCategory);
            var newStyle = styles.find(function(s) { return s.styleId === styleId; });
            
            if (newStyle) {
              var newRules = newStyle.rules || {};
              var currentText = state.currentText || '';
              var isCompatible = isInputCompatible(newRules, currentText);
              
              var oldColorCode = state.selectedColor;
              var oldPlacementId = state.selectedPlacement;
              
              state.selectedStyle = styleId;
              
              var matchedColor = findMatchingColor(newStyle, oldColorCode);
              if (matchedColor) {
                state.selectedColor = matchedColor.code;
              } else if (newStyle.colors && newStyle.colors.length > 0) {
                state.selectedColor = newStyle.colors[0].code;
              } else {
                state.selectedColor = null;
              }
              
              var matchedPlacement = findMatchingPlacement(newStyle, oldPlacementId);
              if (matchedPlacement) {
                state.selectedPlacement = matchedPlacement.placementId;
              } else if (newStyle.placements && newStyle.placements.length > 0) {
                state.selectedPlacement = newStyle.placements[0].placementId;
              } else {
                state.selectedPlacement = null;
              }
              
              if (!isCompatible) {
                state.currentText = '';
                var inputField = formBody.querySelector('.cpc-char-input');
                if (inputField) {
                  inputField.value = '';
                }
                var counter = formBody.querySelector('.cpc-char-counter');
                if (counter) {
                  var max = inputField ? inputField.dataset.max || 20 : 20;
                  counter.textContent = '0/' + max;
                }
                var msgEl = formBody.querySelector('.cpc-validation-message');
                if (msgEl) {
                  msgEl.classList.remove('visible');
                  var textEl = msgEl.querySelector('.cpc-msg-text');
                  if (textEl) textEl.textContent = '';
                }
              }
              
              renderSections();
              updateMonogramDisplay();
              activateMonogramPreview();
              writePropertiesToForm();
              updateValidationMessage();
            }
          });
        });
      });

      // Color swatches
      formBody.querySelectorAll('.cpc-color-swatch').forEach(function(sw) {
        sw.addEventListener('click', function() {
          waitForReady(function() {
            if (!state.selectedCategory) {
              showTooltip('Please select a category first');
              return;
            }
            
            injectMonogramSlidesOnFirstInteraction();
            
            state.selectedColor = sw.dataset.color;
            formBody.querySelectorAll('.cpc-color-swatch').forEach(function(s) { s.classList.remove('selected'); });
            sw.classList.add('selected');
            var label = formBody.querySelector('.cpc-color-current-label');
            if (label) label.textContent = sw.dataset.colorName || "";
            updateMonogramDisplay();
            activateMonogramPreview();
            writePropertiesToForm();
            updateValidationMessage();
          });
        });
      });

      // Placement buttons
      formBody.querySelectorAll('.cpc-placement-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          waitForReady(function() {
            if (!state.selectedCategory) {
              showTooltip('Please select a category first');
              return;
            }

            injectMonogramSlidesOnFirstInteraction();

            var placementId = parseInt(btn.dataset.placementId, 10);
            state.selectedPlacement = placementId;

            formBody.querySelectorAll('.cpc-placement-btn').forEach(function(b) { b.classList.remove('selected'); });
            btn.classList.add('selected');

            var placementLabelEl = formBody.querySelector('.cpc-placement-current-label');
            var btnLabelEl = btn.querySelector('.cpc-placement-label');
            if (placementLabelEl) placementLabelEl.textContent = btnLabelEl ? btnLabelEl.textContent : '';

            updateMonogramDisplay();
            activateMonogramPreview();
            writePropertiesToForm();
            updateValidationMessage();
          });
        });
      });

      // Text input
      var input = formBody.querySelector('.cpc-char-input');
      if (input) {
        input.addEventListener('input', function(e) {
          waitForReady(function() {
            if (!state.selectedCategory) {
              showTooltip('Please select a category first');
              e.target.value = '';
              return;
            }
            
            injectMonogramSlidesOnFirstInteraction();
            
            var type = e.target.dataset.inputType || 'text';
            var max = parseInt(e.target.dataset.max, 10) || 20;
            var min = parseInt(e.target.dataset.min, 10) || 0;
            var isDate = type === 'date';

            if (isDate) {
              var digits = e.target.value.replace(/[^0-9]/g, '').slice(0, 6);
              var formatted = digits;
              if (digits.length > 2) {
                formatted = digits.slice(0, 2) + '-' + digits.slice(2);
              }
              if (digits.length > 4) {
                formatted = digits.slice(0, 2) + '-' + digits.slice(2, 4) + '-' + digits.slice(4);
              }
              e.target.value = formatted;
              state.currentText = digits;
              var counter = formBody.querySelector('.cpc-char-counter');
              if (counter) counter.textContent = digits.length + '/6';
            } else {
              var val = e.target.value;
              if (type === 'letters') val = val.replace(/[^a-zA-Z]/g, '');
              else if (type === 'numbers') val = val.replace(/[^0-9]/g, '');
              else if (type === 'alphanumeric') val = val.replace(/[^a-zA-Z0-9]/g, '');
              if (val.length > max) val = val.slice(0, max);
              e.target.value = val;
              state.currentText = val;
              var counter2 = formBody.querySelector('.cpc-char-counter');
              if (counter2) counter2.textContent = val.length + '/' + max;
              var hint = formBody.querySelector('.cpc-char-hint');
              if (hint) {
                hint.classList.toggle('cpc-error-msg', min > 0 && val.length > 0 && val.length < min);
              }
            }

            updateMonogramDisplay();
            activateMonogramPreview();
            writePropertiesToForm();
            updateValidationMessage();
          });
        });
      }

      // Clear button
      var clearBtn = formBody.querySelector('.cpc-clear-btn');
      if (clearBtn) {
        clearBtn.addEventListener('click', function() {
          waitForReady(function() {
            if (!state.selectedCategory) {
              showTooltip('Please select a category first');
              return;
            }
            
            injectMonogramSlidesOnFirstInteraction();
            
            state.currentText = '';
            
            var inputField = formBody.querySelector('.cpc-char-input');
            if (inputField) {
              inputField.value = '';
            }
            
            var counter = formBody.querySelector('.cpc-char-counter');
            if (counter) {
              var max = inputField ? inputField.dataset.max || 20 : 20;
              counter.textContent = '0/' + max;
            }
            
            var hint = formBody.querySelector('.cpc-char-hint');
            if (hint) {
              hint.classList.remove('cpc-error-msg');
            }
            
            var msgEl = formBody.querySelector('.cpc-validation-message');
            if (msgEl) {
              msgEl.classList.remove('visible');
              var textEl = msgEl.querySelector('.cpc-msg-text');
              if (textEl) textEl.textContent = '';
            }
            
            updateMonogramDisplay();
            activateMonogramPreview();
            writePropertiesToForm();
            updateValidationMessage();
          });
        });
      }

      updateMonogramDisplay();
      updateAddToCartButton();
    }

    // ============================================================
    // WRITE PROPERTIES TO FORM (Beta version)
    // ============================================================
    function writePropertiesToForm() {
      // Beta uses product-info-form custom element
      const form = document.querySelector('product-info-form form[action$="/cart/add"]');
      if (!form) { 
        // Fallback to regular form selector
        const fallbackForm = document.querySelector('form[action$="/cart/add"]');
        if (!fallbackForm) { warn('Product form not found'); return; }
        writePropertiesToFormElement(fallbackForm);
        return;
      }
      writePropertiesToFormElement(form);
    }

    function writePropertiesToFormElement(form) {
      let propsContainer = form.querySelector('.customizer-properties');
      if (!propsContainer) {
        propsContainer = document.createElement('div');
        propsContainer.className = 'customizer-properties';
        propsContainer.style.display = 'none';
        form.appendChild(propsContainer);
      }

      const style = getCurrentStyle();
      const placement = getCurrentPlacement();
      const colorObj = getCurrentColor();

      if (!style) return;

      propsContainer.innerHTML = '';

      const colorValue = colorObj?.name || '';

      let textValue = state.currentText || '';
      const rules = style.rules || {};
      if (rules.inputType === 'date' && textValue) {
        const digits = textValue.replace(/[^0-9]/g, '');
        if (digits.length > 0) {
          let formatted = digits;
          if (digits.length > 2) {
            formatted = digits.slice(0, 2) + '-' + digits.slice(2);
          }
          if (digits.length > 4) {
            formatted = digits.slice(0, 2) + '-' + digits.slice(2, 4) + '-' + digits.slice(4);
          }
          textValue = formatted;
        }
      }

      [
        { key: 'Category', val: state.selectedCategory || '' },
        { key: 'Style', val: style.name || '' },
        { key: 'Color', val: colorValue },
        { key: 'Placement', val: placement?.label || '' },
        { key: 'Text', val: textValue },
      ].forEach(({ key, val }) => {
        if (!val) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = val;
        propsContainer.appendChild(input);
      });

      // Sync to all other forms
      const allForms = document.querySelectorAll('form[action$="/cart/add"]');
      allForms.forEach(otherForm => {
        if (otherForm === form) return;
        let mirror = otherForm.querySelector('.customizer-properties');
        if (!mirror) {
          mirror = document.createElement('div');
          mirror.className = 'customizer-properties';
          mirror.style.display = 'none';
          otherForm.appendChild(mirror);
        }
        mirror.innerHTML = propsContainer.innerHTML;
      });

       updateAddToCartButton();
    }

    // ============================================================
    // UPDATE ADD TO CART BUTTON (Beta version)
    // ============================================================
    function updateAddToCartButton() {
      var isValid = isCurrentSelectionValid();
      
      var atcBtns = document.querySelectorAll('.p-info-add-to-cart');
      var propsContainer = document.querySelector('.customizer-properties');
      
      if (isValid && propsContainer) {
          atcBtns.forEach(function(atcBtn) {
              atcBtn.disabled = false;
              atcBtn.removeAttribute('disabled');
              atcBtn.classList.remove('cpc-disabled-atc');
          });
      } else {
          atcBtns.forEach(function(atcBtn) {
              atcBtn.disabled = true;
              atcBtn.setAttribute('disabled', 'disabled');
              atcBtn.classList.add('cpc-disabled-atc');
          });
      }
      
      attachAtcClickListeners();
    }


    // ============================================================
    // ATTACH ATC CLICK LISTENERS (Beta version)
    // ============================================================

    function attachAtcClickListeners() {
      if (document._cpcAtcDelegated) return;
      document._cpcAtcDelegated = true;

      document.addEventListener('click', function(e) {
          var form = e.target.closest('form[action$="/cart/add"]');
          if (!form) return;

          var currentBtn = form.querySelector('.p-info-add-to-cart');
          if (!currentBtn || !currentBtn.classList.contains('cpc-disabled-atc')) {
              return;
          }

          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          var body = document.body;
          if (body.style.overflow === 'hidden') {
              var pqaPopup = document.querySelector('.pqa-popup');
              if (pqaPopup && pqaPopup.classList.contains('active')) {
                  pqaPopup.classList.remove('active');
                  body.style.height = '';
                  body.style.overflow = '';
              }
          }

          var message = 'Please complete your selections first.';
          if (!state.selectedCategory) {
              message = 'Please select a category first.';
          } else if (!state.selectedStyle) {
              message = 'Please select a style first.';
          } else if (!state.selectedColor) {
              message = 'Please select a thread color first.';
          } else if (!state.selectedPlacement) {
              message = 'Please select a placement first.';
          } else if (!state.currentText || state.currentText.length === 0) {
              message = 'Please enter your text.';
          }

          showTooltip(message);
          scrollToCategorySection();
      }, true);
    }

    // ============================================================
    // VALIDATION
    // ============================================================
    function isCurrentSelectionValid() {
      const style = getCurrentStyle();
      if (!style) return false;

      const rules = style.rules || {};
      const inputType = rules.inputType || 'text';
      const text = state.currentText || '';
      const textLen = text.length;

      if (textLen === 0) return false;
      
      if (inputType === 'date') {
        const digits = text.replace(/[^0-9]/g, '');
        return digits.length === 6;
      }
      
      if (inputType === 'letters' && !/^[a-zA-Z]*$/.test(text)) return false;
      if (inputType === 'numbers' && !/^[0-9]*$/.test(text)) return false;
      if (inputType === 'alphanumeric' && !/^[a-zA-Z0-9]*$/.test(text)) return false;
      
      const minLen = rules.minLength || 0;
      const maxLen = rules.maxLength || 999;
      if (minLen > 0 && textLen < minLen) return false;
      if (maxLen < 999 && textLen > maxLen) return false;

      return true;
    }

    function getValidationMessage(style, text) {
      if (!style) return '';
      
      const rules = style.rules || {};
      const inputType = rules.inputType || 'text';
      const minLen = rules.minLength || 0;
      const maxLen = rules.maxLength || 999;
      const textLen = text.length;
      const digits = text.replace(/[^0-9]/g, '');
      
      if (textLen === 0) return '';
      
      if (inputType === 'date') {
        if (digits.length > 0 && digits.length < 6) {
          return `Please enter 6 digits (DDMMYY). Currently ${digits.length}/6 digits entered.`;
        }
        if (digits.length === 6) return '';
        if (text !== digits) return 'Only numbers (0-9) are allowed for date format.';
        return '';
      }
      
      if (inputType === 'letters' && !/^[a-zA-Z]*$/.test(text)) {
        return 'Only letters (A-Z) are allowed for this style.';
      }
      if (inputType === 'numbers' && !/^[0-9]*$/.test(text)) {
        return 'Only numbers (0-9) are allowed for this style.';
      }
      if (inputType === 'alphanumeric' && !/^[a-zA-Z0-9]*$/.test(text)) {
        return 'Only letters and numbers are allowed for this style.';
      }
      
      if (minLen > 0 && textLen < minLen) {
        return `Minimum ${minLen} character${minLen > 1 ? 's' : ''} required.`;
      }
      if (maxLen < 999 && textLen > maxLen) {
        return `Maximum ${maxLen} character${maxLen > 1 ? 's' : ''} allowed.`;
      }
      
      return '';
    }

    function updateValidationMessage() {
      const style = getCurrentStyle();
      const text = state.currentText || '';
      
      const validationMsg = getValidationMessage(style, text);
      const isValid = validationMsg === '';
      
      const msgEl = document.querySelector('.cpc-validation-message');
      if (msgEl) {
        const textEl = msgEl.querySelector('.cpc-msg-text');
        if (textEl) textEl.textContent = validationMsg;
        msgEl.classList.toggle('visible', !isValid && text.length > 0);
      }
      
      updateAddToCartButton();
    }

    // ============================================================
    // COLOR SYNC
    // ============================================================
    function syncColorKey() {
      const checked = document.querySelector('input.pinfo-color-input:checked');
      if (!checked) return;
      const newKey = checked.value.toLowerCase().trim();
      if (newKey === state.colorKey || !CUSTOM_DATA[newKey]) return;

      log('Color variant changed to:', newKey);
      
      setLoadingState(true, CPC_CONFIG.LOADING_TIMEOUT_COLOR_CHANGE);
      
      state.colorKey = newKey;
      state.selectedCategory = null;
      state.selectedStyle = null;
      state.selectedColor = null;
      state.selectedPlacement = null;
      state.currentText = '';

      slidesInjected = false;
      desktopSlideInserted = false;
      mobileSlideInserted = false;

      // Remove existing injected slides
      document.querySelectorAll('.cpc-monogram-slide-wrapper').forEach(el => el.remove());

      // Update preview image
      updatePreviewImage();

      // Re-render the form with no selections
      renderSections();
      writePropertiesToForm();
      updateValidationMessage();

      updateAddToCartButton();

      log('Color changed - slides removed, ready for re-injection');
    }

    // ============================================================
    // INITIALIZATION
    // ============================================================
    function init() {
      setLoadingState(true, CPC_CONFIG.LOADING_TIMEOUT);
      renderSections();
      writePropertiesToForm();
      updateValidationMessage();
      updatePreviewImage();
      updateAddToCartButton();

      document.addEventListener('variant:change', syncColorKey);
      document.addEventListener('input', function(e) {
        if (e.target?.classList?.contains('pinfo-color-input')) {
          syncColorKey();
        }
      });

      isInitialized = true;
      log('Custom Placement initialized - waiting for user interaction');
    }

    // Wait for DOM to be ready and then initialize
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(init, 500);
      });
    } else {
      setTimeout(init, 500);
    }

    // Expose API for rechecking state
    window.__placementRecheck = function() {
      if (isInitialized) {
        syncColorKey();
        renderSections();
        writePropertiesToForm();
        updateValidationMessage();
      }
    };

    window.__customizerWriteProperties = function() {
      if (isInitialized) {
        writePropertiesToForm();
      }
    };

    window.CustomPlacement = window.CustomPlacement || {};
    window.CustomPlacement.instance = {
      reattachEventListeners: function() {
        if (formBody) {
          attachEventListeners();
        }
      },
      recheckState: function() {
        if (isInitialized) {
          syncColorKey();
          renderSections();
          writePropertiesToForm();
          updateValidationMessage();
        }
      },
      writeProperties: function() {
        if (isInitialized) {
          writePropertiesToForm();
        }
      }
    };

    window.addEventListener('beforeunload', function() {
      removeTooltip();
      if (tooltipTimeout) {
        clearTimeout(tooltipTimeout);
        tooltipTimeout = null;
      }
    });

    log('Custom Placement inline script loaded');

  })();